const POSITION_PREFIX = "7cut.pos.";
const STALE_MS = 30 * 24 * 60 * 60 * 1000; // 30 дней

export const MIN_POSITION_SEC = 5;
const RESUME_OFFSET_SEC = 3;
const END_THRESHOLD_SEC = 10;

export const positionKey = (versionId) => `${POSITION_PREFIX}${versionId}`;

const safeParse = (raw, fallback) => {
  if (!raw) return fallback;
  try {
    return JSON.parse(raw);
  } catch (e) {
    return fallback;
  }
};

export const readPosition = (versionId) => {
  const position = safeParse(
    localStorage.getItem(positionKey(versionId)),
    null
  );
  if (!position) return null;

  const { t, duration, savedAt } = position;

  if (typeof savedAt !== "number" || Date.now() - savedAt > STALE_MS) {
    localStorage.removeItem(positionKey(versionId));
    return null;
  }

  if (typeof t !== "number" || !Number.isFinite(t)) return null;
  if (t < MIN_POSITION_SEC) return null;
  if (typeof duration !== "number" || !Number.isFinite(duration)) return null;
  if (duration <= 0 || t > duration - END_THRESHOLD_SEC) return null;

  return { t, duration, savedAt };
};

export const clearPosition = (versionId) => {
  localStorage.removeItem(positionKey(versionId));
};

export const savePosition = (versionId, t, duration) => {
  if (!Number.isFinite(t) || t < MIN_POSITION_SEC) {
    clearPosition(versionId);
    return;
  }

  localStorage.setItem(
    positionKey(versionId),
    JSON.stringify({
      t,
      duration: Number.isFinite(duration) && duration > 0 ? duration : 0,
      savedAt: Date.now(),
    })
  );
};

export const resumeTarget = (position) =>
  Math.max(0, position.t - RESUME_OFFSET_SEC);

export const formatClock = (seconds) => {
  const safe = Number.isFinite(seconds) && seconds > 0 ? seconds : 0;
  const minutes = Math.floor(safe / 60);
  const rest = Math.floor(safe % 60);
  return `${String(minutes).padStart(2, "0")}:${String(rest).padStart(2, "0")}`;
};
